import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({ providedIn: "root" })
export class DsIconsService {
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer, private http: HttpClient) {
    this.loadIcons();
  }

  private loadIcons() {
    const baseUrl = "https://nexu-rebranding-2025.s3.us-east-1.amazonaws.com/icons/figma";

    this.http.get<string[]>(`${baseUrl}/iconography.json`).subscribe((icons) => {
      icons.forEach((name) => {
        this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/${name}.svg`));
      });
    });
  }
}
